module.exports = __webpack_public_path__ + "img/zglt.b5192d0d.png";